<template>
  <div class="product-specs">
    <input type="hidden" name="specs" v-model="specsImploded" />
    <input type="hidden" name="specs_cols" v-model="specsHeadersImploded" />

    <table class="table table-sm">
      <thead>
        <tr class="headers">
          <th v-for="(col, index) in headers"
              :key="index">
            <div class="actions">
              <button class="btn btn-sm edit action" type="button" @click="moveCol(index, -1)">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button class="btn btn-sm btn-danger action" type="button" @click="removeCol(index)">
                <i class="far fa-trash-alt"></i>
              </button>
              <button class="btn btn-sm edit action" type="button" @click="moveCol(index, 1)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
            <input type="text"
                   v-model="headers[index]"
                   placeholder="Enter spec name"
                   class="form-control"
                   @change="rebuildSpecs"
            />
          </th>
          <th>
            <button class="btn btn-sm btn-success action"
                    type="button"
                    @click="addCol">
              <i class="fas fa-circle-plus"></i>
            </button>
          </th>
        </tr>
        <tr>
          <td :colspan="headers.length">
            &nbsp;
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(spec, index) in product.specs"
            :key="index">
          <td v-for="col in headers">
            <input type="text"
                   class="form-control"
                   v-model="spec[col]"
            />
          </td>
          <td>
            <div class="actions">
              <button class="button action remove"
                      type="button"
                      @click="remove(index)">
                <i class="far fa-trash-alt"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td :colspan="headers.length">
            <button class="btn btn-success"
                    type="button"
                    @click="addSpec">
              Add spec row
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: "ProductSpecs",
  props: ['product'],
  data() {
    return {
      headers: [],
      specsHeadersImploded: ''
    }
  },
  mounted() {
    setTimeout(() => {
      this.headers = JSON.parse(JSON.stringify(this.product.specs_cols)) || Object.keys(this.product.specs[0] || {})
    }, 50)
  },
  watch: {
    headers: {
      deep: true,
      handler(){
        this.specsHeadersImploded = JSON.stringify(this.headers)
      }
    }
  },
  methods: {
    addCol() {
      this.headers.push('New spec')
      this.rebuildSpecs()
    },
    moveCol(index, step){
      let newIndex = index + step

      if(newIndex < 0 || newIndex === this.headers.length){
        return
      }

      let oldVal = this.headers[newIndex]
      this.headers[newIndex] = this.headers[index]
      this.headers[index] = oldVal

      this.specsHeadersImploded = JSON.stringify(this.headers)

      for (let specI = 0; specI < this.product.specs.length; specI++) {
        let spec = this.product.specs[specI]
        let newSpec = {}
        this.headers.forEach((v, index) => {
          newSpec[v] = spec[v]
        })

        this.product.specs[specI] = newSpec
      }

      this.$forceUpdate()
    },
    removeCol(index){
      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this spec?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              this.headers.splice(index, 1)
              this.rebuildSpecs()
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    },
    rebuildSpecs() {
      this.product.specs = this.product.specs || []

      for (let specI = 0; specI < this.product.specs.length; specI++) {
        let spec = this.product.specs[specI]
        let specVals = Object.values(spec)
        let newSpec = {}
        specVals.forEach((v, index) => {
          newSpec[this.headers[index]] = v
        })

        this.product.specs[specI] = newSpec
      }
    },
    addSpec() {
      let newSpec = {}

      this.headers.forEach((col) => {
        newSpec[col] = ''
      })

      this.product.specs.push(newSpec)
    },
    remove(index) {
      let spec = this.product.specs[index]

      let nonEmptyValues = Object.values(spec).filter(v => !!v)

      if (nonEmptyValues.length === 0) {
        return this.product.specs.splice(index, 1)
      }

      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this spec?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              this.product.specs.splice(index, 1)
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    }
  },
  computed: {
    specsImploded(){
      return JSON.stringify(this.product.specs)
    }
  }
}
</script>

<style scoped>

</style>
